import { clearCoupons } from "@/api/coupons";
import { CouponsQueryKeys } from "@/tanstackQuery/queries";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useClearCoupons = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: clearCoupons,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [CouponsQueryKeys.History],
      });
      queryClient.invalidateQueries({ queryKey: ["coupons", "search"] });
    },
  });
};
